import React, { useState } from "react";
import "../auth/auth.css";
import EmailIcon from "@mui/icons-material/Email";
import { useForm } from "react-hook-form";
import usePasswordToggle from "../hooks/usePasswordToggle";
import { createUserWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../config/Firebase";
import { Card } from "react-bootstrap";
import AlertDisplay from "../../../../componenets/AlertDisplay";

const Auth = ({ setKey }) => {
  const [alertText, setAlertText] = useState("");
  const [alertType, setAlertType] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { isDirty, dirtyFields, isLoading, errors, isValid },
    getValues,
  } = useForm({
    shouldUseNativeValidation: true,
    defaultValues: {
      email: "",
      password: "",
    },
    mode: "onChange",
  });

  const onSubmit = async (values) => {
    const email = values.email;
    const password = values.password;
    signIn(auth, email, password);
  };

  const signIn = async (auth, email, password) => {
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      setAlertText("Login Successfully!");
      setAlertType("success");
      setShowAlert(true);
    } catch (err) {
      setAlertText(`Error:${err}`);
      setAlertType("danger");
      setShowAlert(true);
    }
  };

  const signInWithGoogle = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      setAlertText("Login Successfully!");
      setAlertType("success");
      setShowAlert(true);
    } catch (err) {
      setAlertText(`Error:${err}`);
      setAlertType("danger");
      setShowAlert(true);
    }
  };

  const [InputType, toggleIcon] = usePasswordToggle();

  return (
    <>
      {showAlert && alertType && alertText && (
        <AlertDisplay
          alertType={alertType}
          alertText={alertText}
          setShowAlert={setShowAlert}
        />
      )}
      <Card>
        <Card.Header>Login</Card.Header>
        <Card.Body>
          <form className="form" onSubmit={handleSubmit(onSubmit)}>
            <p className="form-title">Sign in to your account</p>
            <div className="input-container">
              <input
                placeholder="Enter email"
                type="email"
                {...register("email", { required: "Please enter your email." })}
              />
              <span style={{ marginLeft: "50px" }}>
                <EmailIcon />
              </span>
            </div>
            <div className="input-container">
              <input
                placeholder="Enter password"
                type={InputType}
                {...register("password", {
                  required: "Please enter your password.",
                })}
              />
              <span>{toggleIcon}</span>
            </div>
            <button
              className="submit"
              type="submit"
              disabled={!isDirty || !isValid}
            >
              Sign in
            </button>

            <p style={{ textAlign: "center" }}>Or</p>
            <button
              className="submit"
              style={{ backgroundColor: "transparent", color: "black" }}
              onClick={signInWithGoogle}
            >
              Sign in With Google
            </button>
            <p className="signup-link">
              No account?
              <a href="">Sign up</a>
            </p>
          </form>
        </Card.Body>
      </Card>
    </>
  );
};

export default Auth;
